<template>
    <div>
      <header class="header-area" id="Header">
        <div class="header-center">
          <img src="@/components/header/img/logo.png" alt="超現實logo" class="header-logo" />
        </div>
      </header>
      <div class="header-position"></div>
    </div>
  </template>
  
  <script>
  import '@/components/header/header.scss';
  
  export default {
    name: 'HeaderBackend',
    props: {},
    data() {
      return {

      };
    },
    components: {},
  };
  </script>
  